/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const TrashRestoreIconConfig = {
  name: 'TrashRestoreIcon',
  height: 512,
  width: 448,
  svgPath: 'M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(TrashRestoreIconConfig);
//# sourceMappingURL=trash-restore-icon.js.map